import { maxxApiClient } from '@/clients/MaxxApi';
import { useQuery } from '@tanstack/react-query';

import { LEAD_CACHE_KEY } from '../constants';

export const useCurrentLead = () =>
	useQuery({
		queryFn: () => maxxApiClient.getCurrentLead(),
		queryKey: [LEAD_CACHE_KEY],
	});
